module.exports = __webpack_public_path__ + "static/media/Программа конференции УОМШ-22new.ca91f621.pdf";